module.exports = __webpack_public_path__ + "b624f90865c35ddb61d2b33f0d1f091c.jpg";